import { defineAgenda } from '@/shared/navigation/core';
import { listPageViewState } from '@/shared/navigation/react/listPageViewState';
import i18n from '@/shared/lib/i18n';

/**
 * Agenda seznamu subkategorií placeholderů (číselník). Univerzální ListPage (engine
 * `@/shared/ui/list-page`, šablona `SubcategoryListPage.tsx`). Otevírá detail jako modální vrstvu.
 */
export const subcategoryListAgenda = defineAgenda({
  id: 'app.venua-planner.placeholder-subcategories',
  path: 'app/venua-planner/placeholder-subcategories',
  open: {},
  state: listPageViewState,
  title: () => i18n.t('schemes.subcategoryList.agendaTitle', { ns: 'venua-planner' }),
  icon: 'list',
});
